import { render } from "./IconLinkedIn.vue?vue&type=template&id=73c7ad5c"
import script from "./IconLinkedIn.vue?vue&type=script&lang=js"
export * from "./IconLinkedIn.vue?vue&type=script&lang=js"
script.render = render

export default script